import { Component, Input, OnInit, AfterViewChecked } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  Event as NavigationEvent,
  NavigationEnd,
} from '@angular/router';
import { SearchService } from '../../shared/services/search.service';
import { CommonService } from '../../shared/services/common.service';
import { LoadingService } from '../../shared/services/loading.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { Message } from 'src/app/message';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { MatDialog } from '@angular/material/dialog';
// import { LangaugeDialogComponent } from '../langauge-dialog/langauge-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PageService } from 'src/app/shared/services/page.service';
// import moengage from "@moengage/web-sdk";
import { UserService } from '../../shared/services/user.service';
import { Subscription } from 'rxjs';
declare var webengage: any;

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent implements OnInit, AfterViewChecked {
  search_results: any = [];
  trendingSearchResults: any = [];
  statusMessage: any;
  private _searchNameTerm: string;
  //loadingIndicator: boolean = false;
  contentHeight: number;
  searchError: boolean = false;
  search_results1: boolean = false;
  language: any;
  closeIcon: boolean = false;
  region: string;
  recentSearchTags: any = [];
  session: string = '';
  isshowNoResult: boolean = true;
  browser: string = 'web';
  searchRediect: string = '';
  trendingSearchRedirect: string = '';
  ad_slot1: any = [];
  isSubscribedAcc: string = 'false';
  // defineSlotFlag: boolean = true;
  ads_available: boolean = false;
  banner_ads_available: boolean = false;
  private searchTrackTimer: any = null;
  private searchSub: Subscription;
  // $: any;
  user: any;
  constructor(
    private analytics: AngularFireAnalytics,
    private service: SearchService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private broadcastService: BroadcastService,
    private snackbar: MatSnackBar,
    private pageService: PageService,
    private dialog: MatDialog,
    private userService: UserService,
  ) {
    if (
      this.router['browserUrlTree']?.queryParams &&
      this.router['browserUrlTree']?.queryParams?.browser
    ) {
      this.browser = this.router['browserUrlTree']?.queryParams?.browser;
    }
    if (screen.width < 1200) {
      this.browser = 'mweb';
    } else {
      this.browser = 'web';
    }

    this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
        if (event['snapshot'] && event['snapshot'].queryParams) {
          this.browser = event['snapshot'].queryParams.browser
            ? event['snapshot'].queryParams.browser
            : 'web';
          window.localStorage
            ? window.localStorage.setItem('browser', this.browser)
            : '';
        }
      }

      if ($('#search').val()) {
        this.clearSearch();
        this.getTrendingSearch();
        if (
          (window.localStorage &&
            window.localStorage.getItem('otv_user_id')) !== null &&
          this.browser != 'android' &&
          this.browser != 'ios'
        ) {
          // if(window.localStorage.getItem('otv_user_id') !== null){
          // console.log(window.localStorage.getItem('otv_user_id'))
          this.getRecentSearch();
        }
      }
    });
    this.broadcastService
      .on(new Message('recentsearch', null))
      .subscribe((event) => this.getRecentSearch());

    this.broadcastService
      .on(new Message('bannerAds', null))
      .subscribe((event) => this.bannerAds());
  }

  ngOnInit() {
    if (
      window.localStorage &&
      window.localStorage.getItem('otv_user_id') &&
      this.browser != 'android' &&
      this.browser != 'ios'
    ) {
      // console.log(window.localStorage.getItem('otv_user_id'))
      this.getRecentSearch();
    }
    
    this.getTrendingSearch();
    if (window.localStorage) {
      this.region = window.localStorage.getItem('region');
      this.session = window.localStorage.getItem('otv_user_id');
      this.isSubscribedAcc = this.session
        ? window.localStorage.getItem('is_subscribed')
        : 'false';
    }
    this.contentHeight = this.commonService.pageHeight();

    try {
      this.user = JSON.parse(window.localStorage.getItem('user') || 'null');
    } catch (e) {
      this.user = null;
    }
  }

  ngAfterViewChecked() {}

  bannerAds() {
    if (window.localStorage) {
      this.ads_available =
        window.localStorage.getItem('ad_slot1') != 'undefined'
          ? JSON.parse(window.localStorage.getItem('ad_slot1'))
              ?.showlisitngpage_ad_avialble
          : false;
      this.ad_slot1 =
        window.localStorage.getItem('ad_slot1') != 'undefined'
          ? JSON.parse(window.localStorage.getItem('ad_slot1'))
              ?.showlisitngpage_ad_url
          : undefined;
      this.banner_ads_available =
        window.localStorage.getItem('banner_ads_available') != 'undefined'
          ? JSON.parse(window.localStorage.getItem('banner_ads_available'))
          : false;
    }
    if (
      this.banner_ads_available &&
      this.ads_available &&
      this.isSubscribedAcc != 'true'
    ) {
      const googletag = window.googletag || { cmd: [] };
      // this.ad_slot1 = window.localStorage ? JSON.parse(window.localStorage.getItem('ad_slot1')) : '';
      let adslot = this.ad_slot1;
      // this.defineSlotFlag = false;
      $(document).ready(function () {
        if (
          $('#banner-ad-search')?.children().length == 0 &&
          adslot['adUnitPath']
        ) {
          $('#banner-ad-search').css('width', JSON.parse(adslot['size'])[0][0]);
          $('#banner-ad-search').css(
            'height',
            JSON.parse(adslot['size'])[0][1],
          );
          googletag.cmd.push(function () {
            googletag
              .defineSlot(
                // '/6355419/Travel/Europe/France/Paris', [300, 250], adslot['opt_div']+'-search')
                adslot['adUnitPath'],
                JSON.parse(adslot['size']),
                'banner-ad-search',
              )
              // .setTargeting('test', 'refresh')
              .addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.enableServices();
            googletag.display('banner-ad-search');
            // googletag.pubads().disableInitialLoad();
            // googletag.enableServices();
          });
          $('#banner-ad-search')?.children().length == 0
            ? $('#banner-ad-search').css('display', 'none')
            : $('#banner-ad-search').css('display', 'block');
        }
      });
    }
  }

  getTrendingSearch() {
    this.search_results1 = false;

    //this.loadingIndicator = true;

    if (window.localStorage) {
      this.language = window.localStorage.getItem('language');
      this.region = window.localStorage.getItem('region');
    }
    const parentControl =
      window.localStorage.getItem('parentalControl') === 'true'; // Check parental control
    const regionWithParams = parentControl
      ? `${this.region}&parental_control=true`
      : this.region;
    this.loadingService.showLoader();
    this.service.getTrendingSearch(this.language, regionWithParams).subscribe(
      (response) => {
        //this.loadingIndicator = false;
        this.loadingService.hideLoader();
        this.trendingSearchResults = response.data.catalog_list_items;
        // console.log(this.search_results);
      },
      (error: any) => {
        //this.loadingIndicator = false;
        this.loadingService.hideLoader();
        // console.log(error);
        this.statusMessage = error;
      },
    );
  }

  getRecentSearch() {
    this.loadingService.showLoader();
    if (this.session) {
      const parentControl =
        window.localStorage.getItem('parentalControl') === 'true'; // Check parental control
      this.service.getRecentSearch(this.session, false).subscribe(
        (response) => {
          //this.loadingIndicator = false;
          this.loadingService.hideLoader();
          this.recentSearchTags = response.data.items;
          // console.log(this.search_results);
        },
        (error: any) => {
          //this.loadingIndicator = false;
          this.loadingService.hideLoader();
          // console.log(error);
          this.statusMessage = error;
          if (error.server_error_code === '1016') {
            this.broadcastService.dispatch(new Message('sessionExpired', null));
          }
        },
      );
    }
  }

  showSnackbarMsg(msg, type) {
    if (type === 'success') {
      this.snackbar.open(msg, 'X', {
        verticalPosition: 'top',
        horizontalPosition: 'center',
        duration: 3000,
        panelClass: ['success-snackbar'],
      });
    } else if (type === 'warning') {
      this.snackbar.open(msg, 'X', {
        verticalPosition: 'top',
        horizontalPosition: 'center',
        duration: 3000,
        panelClass: ['alert-snackbar'],
      });
    } else if (type === 'info') {
      this.snackbar.open(msg, 'X', {
        verticalPosition: 'top',
        horizontalPosition: 'center',
        duration: 3000,
        panelClass: ['info-snackbar'],
      });
    } else {
      this.snackbar.open(msg, 'X', {
        verticalPosition: 'top',
        horizontalPosition: 'center',
        // duration:3000,
        panelClass: ['red-snackbar'],
      });
    }
  }

  clearRecentSearch() {
    this.service.getRecentSearch(this.session, true).subscribe(
      (response) => {
        //this.loadingIndicator = false;
        this.loadingService.hideLoader();
        this.recentSearchTags = [];
        this.showSnackbarMsg(response['message'], 'info');
        // Recent Search History Cleared Successfully
        // console.log(this.search_results);
      },
      (error: any) => {
        //this.loadingIndicator = false;
        this.loadingService.hideLoader();
        // console.log(error);
        this.statusMessage = error;
        if (error.server_error_code === '1016') {
          this.broadcastService.dispatch(new Message('sessionExpired', null));
        }
      },
    );
  }

  private trackSearch(query: string, resultsCount: number): void {
    try {
      const results_count = Math.floor(Number(resultsCount) || 0);
      const payload = {
        query,
        results_count,
        is_zero_result: results_count === 0,
        query_length: (query || '').length,
        search_type: 'text',
        source_screen: 'search',
      };
      console.log('WebEngage Search', payload);
      webengage.track('Search', payload);
    } catch (e) {}
  }

  onSearch(val: string) {
    this.region = window.localStorage
      ? window.localStorage.getItem('region')
      : '';
    const parentControl =
      window.localStorage.getItem('parentalControl') === 'true'; // Check parental control
    const regionWithParams = parentControl
      ? `${this.region}&parental_control=true`
      : this.region;
    if (val) {
      const pattern = /[a-zA-Z0-9]/; // Regular expression to allow only letters and numbers
      // const inputChar = String.fromCharCode(val);

      if (!pattern.test(val)) {
        return; // Prevent the input of the invalid character
      } else {
        this.language = window.localStorage
          ? window.localStorage.getItem('language')
          : '';
        if (val.length >= 2) {
          this.closeIcon = true;
          this.searchError = false;
          //this.loadingIndicator = true;
          this.loadingService.showLoader();

          if (this.searchSub) { this.searchSub.unsubscribe(); }
          this.searchSub = this.service
            .getSearchResults(val, this.language, regionWithParams, '')
            .subscribe(
              (response) => {
                // Ignore stale response if user already cleared the box
                const currentVal = ($('#search').val() || '').toString().trim();
                if (!currentVal || currentVal.length < 2) {
                  this.loadingService.hideLoader();
                  return;
                }
                //this.loadingIndicator = false;
                this.loadingService.hideLoader();
                if (response.data.items.length > 0) {
                  this.search_results1 = true;
                  this.search_results = response.data.items;
                  this.isshowNoResult = true;
                  console.log('%c[DEBOUNCE] keystroke received at', 'color: orange', Date.now(), 'val:', val);
                  if (this.searchTrackTimer) { clearTimeout(this.searchTrackTimer); console.log('%c[DEBOUNCE] cleared previous timer', 'color: red'); }
                  this.searchTrackTimer = setTimeout(() => {
                    this.trackSearch(val, this.search_results?.length || 0);
                  }, 1800);
               
} else {
  this.search_results = response.data.items;
  this.isshowNoResult = false;
  if (this.searchTrackTimer) { clearTimeout(this.searchTrackTimer); }
  this.searchTrackTimer = setTimeout(() => {
    this.trackSearch(val, 0);
  }, 1800);
  // this.showNoResult()
  return;
}
                //console.log(this.search_results);
              },
              (error: any) => {
                //this.loadingIndicator = false;
                this.loadingService.hideLoader();
                //console.log(error);
                this.statusMessage = error;
                this.search_results1 = true;
                this.search_results.length = 0;
              },
            );
        } else {
          //$('.search-box-wrap .fa-times').css('display', 'none');
          //this.searchError = true;
          //console.log("yes")
          // this.search_results.length = 0;
          // this.search_results = [];
          this.search_results1 = false;
          this.closeIcon = false;
          this.search_results = [];
          this.isshowNoResult = true;
          this.getTrendingSearch();
          this.loadingService.hideLoader();
          //console.log(this.search_results);
        }
      }
    } else {
      // Empty search box → clear results and show Trending Search
      if (this.searchSub) { this.searchSub.unsubscribe(); this.searchSub = null; }
      this.search_results1 = false;
      this.closeIcon = false;
      this.search_results = [];
      this.isshowNoResult = true;
      this.getTrendingSearch();
      this.loadingService.hideLoader();
    }
  }

  onHitEnterSearch(val, resultClick: boolean) {

    // console.log('@@@@@@@@@@Clicked position:', index);
    if (window.localStorage) {
      this.language = window.localStorage.getItem('language');
      this.region = window.localStorage.getItem('region');
    }
    // console.log(val)
    if (val.length > 0) {
      this.closeIcon = true;
      this.searchError = false;
      //this.loadingIndicator = true;
      this.loadingService.showLoader();

      this.service
        .getSearchResults(val, this.language, this.region, this.session)
        .subscribe(
          (response) => {
            //this.loadingIndicator = false;
            this.loadingService.hideLoader();
            if (resultClick === false) {
              if (response.data.items.length > 0) {
                this.search_results1 = true;
                this.search_results = response.data.items;
                this.isshowNoResult = true;
              } else {
                this.search_results = response.data.items;
                this.isshowNoResult = false;
                // this.showNoResult()
                return;
              }
            }

            //console.log(this.search_results);
          },
          (error: any) => {
            //this.loadingIndicator = false;
            this.loadingService.hideLoader();
            //console.log(error);
            this.statusMessage = error;
            this.search_results1 = true;
            this.search_results.length = 0;
            if (error.server_error_code === '1016') {
              this.broadcastService.dispatch(
                new Message('sessionExpired', null),
              );
            }
          },
        );
    } else {
      //$('.search-box-wrap .fa-times').css('display', 'none');
      //this.searchError = true;
      //console.log("yes")
      // this.search_results.length = 0;
      // this.search_results = [];
      this.search_results1 = false;
      this.closeIcon = false;
      this.search_results = [];
      this.getTrendingSearch();
      this.loadingService.hideLoader();
      //console.log(this.search_results);
    }
  }

  // showNoResult(){
  //   this.dialog.open(LangaugeDialogComponent,{
  //     maxHeight:'600PX',
  //     width:'338PX',
  //     // panelClass: ['search-error-pop'],
  //     data:'search'
  //   }).afterClosed().subscribe(item => {
  //     // console.log('item', item);
  //     if(item === 'yes'){
  //       this.closePop();
  //     }
  //   })
  // }

  clearSearch() {
    if (this.searchSub) { this.searchSub.unsubscribe(); this.searchSub = null; }
    $('#search').val('');
    this.search_results1 = false;
    this.closeIcon = false;
    this.search_results = [];
    this.isshowNoResult = true;
    this.getTrendingSearch();
  }

  onClickSearchResult(s: any, i: number, typedSearchTerm: string = '') {
    try {
      const artworkData = {
        content_id: s?.content_id || '',
        artwork_type: 'thumbnail',
        artwork_position: (i || 0) + 1,
        container: 'search result',
        title: s?.display_title || s?.title || '',
        source_screen: 'search',
      };
      webengage.track('Artwork Click', artworkData);
    } catch (e) {}
    try {
      window.localStorage.setItem('globalTabName', 'search');
      window.localStorage.setItem('globalTrayName', 'search result');
      window.localStorage.setItem(
        'globalArtworkPosition',
        String((i || 0) + 1)
      );
    } catch (e) {}
    // console.log('search Item Click', s);
    let item_position = i;
    const totalResults = this.search_results?.length || 0;
   const searchkeyword = typedSearchTerm || s.title || '';
   // console.log('Clicked Position:', i);
    // if(!this.search_results1){
    //Trending Search
    //window.open('https://play.google.com/store/apps/details?id=com.otl.tarangplus');
    //   window.open('/')
    // } else {
    //Search Item
    //if(s.media_type == 'episode'){
    this.broadcastService.dispatch(new Message('sessionEmpty', null));
    this.searchRediect = this.commonService.getItemURL(s);
    // if(s['theme'] == 'episode' || s['theme'] == 'show_episode'){
    //   str = s['catalog_object']['friendly_id'] + '/' + s['show_object']['friendly_id'] + '/' + s['friendly_id'];
    // } else{
    //   str = s['catalog_object']['friendly_id'] + '/' + '/' + s['friendly_id'];
    // }

    // console.log('str', str);
    this.onHitEnterSearch(s.title, true);
    // console.log($('#search').val())
    let query_val = s.title;
   // const searchkeyword = $('#search').val() || s.title || '';
    /*const totalResults = this.search_results?.length > 0 
  ? this.search_results.length 
  : Number($('.search-results-count').text().match(/\d+/)?.[0] || 0);*/
    let content_value = '';
    this.pageService
      .getItemDetails(
        s.langauge,
        s['catalog_object']['friendly_id'],
        s.friendly_id,
        s.regions[0],
      )
      .subscribe(
        (result) => {
          const access_data = result.data.access_control;
          let content_id = result.data.content_id;
          let display_title = result.data.display_title || result.data.title;
          let check_free = result.data.access_control.is_free;
          let is_premium = !check_free;


          console.log("@@@@@@@@@@@@@@@@@content_id:", result.data.content_id);
          if (access_data.is_free) {
            content_value = 'avod';
          } else if (access_data.premium_tag) {
            content_value = 'svod';
          }

          //console.log(searchkeyword)

          this.analytics.logEvent('search_result_clicked', {
            video_name: s.title,
            keyword: searchkeyword,
            clicked: true,
            content_type: s.theme,
            content_value: content_value,
            platform: this.browser,
          });

          const searchResultClickedPayload = {
            query: searchkeyword,
            result_position: item_position + 1,
            content_id: content_id,
            content_type: s.theme,
            content_title: display_title,
            is_premium: is_premium,
          };
          console.log('WebEngage Search Result Clicked', searchResultClickedPayload);
          webengage.track('Search Result Clicked', searchResultClickedPayload);

          // window.sdk.trackEvent("search_Result_Clicked", {
          //   video_name: s.title,
          //   keyword: searchkeyword,
          //   clicked: "true",
          //   content_type: s.theme,
          //   content_value: content_value,
          //   platform: this.browser ? this.browser : "NA",
          //   uid: window.localStorage.getItem('otv_user_id'),
          //   gender: this.user?.gender,
          //   age: this.user?.age.toString(),
          //   is_meghalayan: this.user?.meghalayan_citizen ? 1 : 0,
          //   u_id:this.user?.user_id

          // })
          // moengage.track_event("search_result_clicked",{
          //   video_name: s.title,
          //   keyword:searchkeyword,
          //   clicked: true,
          //   content_type: s.theme,
          //   content_value: content_value

          // })

          let data = {
            video_name: s.title,
            keyword: 'NA',
            clicked: 'true',
            content_type: s.theme,
            content_value: content_value,
            platform: this.browser ? this.browser : 'NA',
            uid: window.localStorage.getItem('otv_user_id'),
            gender: this.user?.gender,
            age: this.user?.age.toString(),
            // is_meghalayan: this.user?.meghalayan_citizen ? 1 : 0,
            u_id: this.user?.user_id,
            event_name: 'search_Result_Clicked',
          };

          this.userService.analytics(data).subscribe(
            (resp) => {
              //console.log(resp);
            },
            (error: any) => {
              if (error.server_error_code === '1016') {
                this.broadcastService.dispatch(
                  new Message('sessionExpired', null),
                );
              }
            },
          );
        },
        (error) => {
          // fire webengage even if getItemDetails fails (e.g. for Shorts)
          const searchResultClickedPayload = {
            query: searchkeyword,
            result_position: item_position + 1,
            content_id: s.content_id || '',
            content_type: s.theme,
            content_title: s.display_title || s.title || '',
            is_premium: false,
          };
          console.log('WebEngage Search Result Clicked', searchResultClickedPayload);
          webengage.track('Search Result Clicked', searchResultClickedPayload);
        },
      );

    // this.router.navigate([this.searchRediect]);
    this.closePop();
  }

  onClickTrendingSearchResult(s) {
    this.broadcastService.dispatch(new Message('sessionEmpty', null));
    // this.trendingSearchRedirect = this.commonService.getItemURL(s);
    // this.router.navigate([this.trendingSearchRedirect]);
    this.closePop();
  }

  hitRecentSearch(str) {
    $('#search').val('');
    $('#search').val(str);
    this.onSearch(str);
  }

  closePop() {
    $('.modal').modal('hide');
    this.clearSearch();
    this.search_results = [];
    this.isshowNoResult = true;
    // if(this.isSubscribedAcc != 'true'){
    //   this.ad_slot1 = JSON.parse(window.localStorage.getItem('ad_slot1'));
    //   const googletag = window.googletag || {cmd: []};
    //   let slot1;
    //   googletag.pubads().getSlots().forEach(slot => {
    //     slot.getSlotElementId().startsWith(this.ad_slot1['opt_div']+'-search') ? googletag.destroySlots([slot]) : '';
    //   });

    // }
  }

  charOnly(event: KeyboardEvent): void {
    const pattern = /[a-zA-Z0-9\s]/; // Regular expression to allow only letters and numbers
    const inputChar = String.fromCharCode(event.keyCode);

    if (!pattern.test(inputChar)) {
      event.preventDefault(); // Prevent the input of the invalid character
    }
  }
}
